module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai122-4cd19a63d8d5b680136af995f0cb7627.jpg";